import { useLocation } from "react-router";

/**
 * Checks if the query string has onboarding mode
 * @returns {boolean}
 */
function useOnboardingQuery() {
  const query = new URLSearchParams(useLocation().search);
  return query?.has("onboarding") && query.get("onboarding") === "true";
}

export default useOnboardingQuery;
